<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelId"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Hạng phòng</div>
                <div class="child-w-80">
                  <el-select v-model="searchParams.roomLevelId" clearable>
                    <el-option
                      v-for="(roomLevel, index) in roomLevelList"
                      :key="index"
                      :value="roomLevel.id"
                      :label="roomLevel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo Khách đến</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div :v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-size-cell="true"
              row-selection="false"
              :auto-select-first-row="false"
              :get-row-height="true"
              :pinned-bottom-row-data="pinnedBottomRowData"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đặt phòng: Hiển thị mã đặt phòng</li>
            <li>Nguồn: nguồn của đặt phòng</li>
            <li>Hạng phòng: hiển thị tên hàng phòng và số phòng</li>
            <li>Ngày đến: ngày đến của đặt phòng</li>
            <li>Ngày đi: ngày đi của đặt phòng</li>
            <li>
              Số đêm: Số đêm được tính từ ngày khách đến đến ngày khách đi
            </li>
            <li>Số khách: số khách của đặt phòng</li>
            <li>Tên khách: Tên khách đặt phòng</li>
            <li>Số điện thoại khách: số điện thoại của khách đặt phòng</li>
            <li>
              Doanh thu sau khi giảm giá: Doanh thu phòng + Phí dịch vụ - Giảm
              giá
            </li>
            <li>Đã cọc: số tiền khách đã cọc</li>
            <li>
              Cần thu: số tiền còn lại cần phải thu = Doanh thu sau khi giảm giá
              - đặt cọc
            </li>
            <li>
              Hiển thị tổng số phòng, Khách, doanh thu: tổng của các ngày trong
              khoảng thời gian tìm kiếm
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getListRoomLevelApi } from '@/api/Room/roomLevel'
import InfoBtn from './components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel'
import { getArriveGuestList } from '@/api/report_service/arriveGuestReport'

export default {
  components: {
    CalendarRange,
    InfoBtn
  },
  data() {
    return {
      loading: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        autoHeight: true,
        wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      hotelList: [],
      searchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      defaultSearchParams: {
        hotelId: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      columns: [
        // {
        //   headerName: '',
        //   field: 'index',
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false
        //   // cellStyle: {'padding-left': '12px'}
        // },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 110,
          tooltipField: 'recode'
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source_code',
          flex: 1,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100,
          tooltipField: 'source_code'
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level_nm',
          tooltipField: 'room_level_nm',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          cellStyle: params => {
            if (params.node.lastChild) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
                // background: 'red'
              }
            }
          },
          minWidth: 120,
          flex: 1

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arrive_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueGetter: params => {
            if (params.data.arrive_date) {
              return this.$moment(params.data.arrive_date).format('DD-MM-YYYY')
            } else {
              return ''
            }
          },
          minWidth: 120,
          maxWidth: 120

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'depart_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          valueGetter: params => {
            if (params.data.depart_date) {
              return this.$moment(params.data.depart_date).format('DD-MM-YYYY')
            } else {
              return ''
            }
          },
          minWidth: 120,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.numNight'),
          field: 'num_of_night',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 70,
          maxWidth: 80
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.roomNo'),
          field: 'room_num',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 70,
          maxWidth: 80
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.numGuest'),
          field: 'num_of_guest',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          // cellClass: "grid-cell-centered",
          cellStyle: params => {
            if (params.node.lastChild) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
              }
            }
          },
          minWidth: 90,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.customerName'),
          tooltipField: 'full_name',
          field: 'full_name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.extraBed'),
          field: 'extra_bed',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipField: 'extra_bed',
          minWidth: 100
          // maxWidth: 200
          // cellClass: "grid-cell-centered",
        }
      ],
      pinnedBottomRowData: null,
      rows: [],
      roomLevelList: []
    }
  },
  created() {
    this.getListHotel()
    this.getRoomLevelOptions()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      this.$message('click on item ' + cmmd)
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getRoomLevelOptions() {
      const data = await getListRoomLevelApi()
      this.roomLevelList = data?.data || []
      // await getRoom()
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    async attachData() {
      this.loading = true
      let data = await getArriveGuestList(this.searchParams)
      this.loading = false
      this.rows = data.data

      if (data.data.length > 0) {
        this.rows.map(data => {
          data.extra_bed =
            data.extra_bed_detail.length == 0
              ? ''
              : data.extra_bed_detail
                  .map(data => `${data.room_surcharge_nm} : ${data.quantity}`)
                  .join(', ')
        })
        this.rows = [
          ...this.rows,
          {
            room_level_nm: `Tổng: ${data.map.total_room} phòng`,
            num_of_guest: `Tổng: ${data.map.total_guest} khách`,
            revenue: `Tổng:  ${Number(data.map.total_revenue).toLocaleString(
              'en'
            )}`,
            rowHeightTotal: true
          }
        ]
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.ag-cell-wrapper {
  top: auto !important;
}
</style>
